module.exports = __webpack_public_path__ + "img/cnd-Interaction.ce145a8a.svg";